import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { mainNav } from '../../data/navigation';
import { Button } from '../ui/Button';
export function MobileMenu({
  id
}: {
  id: string;
}) {
  const [expanded, setExpanded] = useState<string | null>(null);
  return <motion.div id={id} initial={{
    opacity: 0,
    y: -8
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -8
  }} transition={{
    duration: 0.2,
    ease: [0.23, 1, 0.32, 1]
  }} className="fixed inset-x-0 bottom-0 top-[76px] z-40 overflow-y-auto bg-midnight xl:hidden" data-id="element-434" data-mp="21zc4g1fduh4k">
      <nav aria-label="Mobile" className="container-page py-6" data-id="element-435" data-mp="1janlhl0gmlvf">
        <ul className="divide-y divide-white/10" data-id="element-436" data-mp="1j92o7nmrgotv">
          {mainNav.map(item => <li key={item.label} data-id="element-437" data-mp="vjrv8sbnjyqa">
              <div className="flex items-center justify-between" data-id="element-438" data-mp="viqblzgkm3wy">
                <NavLink to={item.to} end={item.to === '/'} className={({
              isActive
            }) => `block flex-1 py-4 font-display text-2xl ${isActive ? 'text-gold-300' : 'text-white'}`} data-id="element-439" data-mp="qlgnqo8ty0b8">
                  {item.label}
                </NavLink>
                {item.children && <button type="button" aria-expanded={expanded === item.label} aria-label={`Show ${item.label} links`} onClick={() => setExpanded(e => e === item.label ? null : item.label)} className="rounded p-3 text-white/70" data-id="element-440" data-mp="dxqlvgqydlco">
                    <ChevronDownIcon className={`h-5 w-5 transition-transform duration-200 ${expanded === item.label ? 'rotate-180' : ''}`} data-id="element-441" data-mp="3mc0credqn9fa" />
                  </button>}
              </div>
              {item.children && expanded === item.label && <ul className="pb-4 pl-1" data-id="element-442" data-mp="16lmiklgivd9g">
                  {item.children.map(c => <li key={c.to + c.label} data-id="element-443" data-mp="32p0z7mgurwo4">
                      <NavLink to={c.to} className="block py-2 text-[15px] text-white/70 hover:text-gold-300" data-id="element-444" data-mp="32nqysqmj2ceb">
                        {c.label}
                      </NavLink>
                    </li>)}
                </ul>}
            </li>)}
        </ul>
        <div className="mt-8 grid gap-3" data-id="element-445" data-mp="37p6ncsnwz11g">
          <Button to="/employers" size="lg" data-id="element-446" data-mp="2jyt15is0fwes">
            Hire Talent
          </Button>
          <Button to="/jobs" size="lg" variant="outlineLight" data-id="element-447" data-mp="2ezzn9p8ta3e3">
            Find Jobs
          </Button>
        </div>
      </nav>
    </motion.div>;
}